import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ApiConnectionString } from "../../constants/ApiConntection";
import axios from "axios";
import { useAuthContext } from "../../hooks/useAuthContext";
import LoadingSpinner from "../../components/LoadingSpinner";
import BookWithTokenModal from "./modals/BookWithTokenModal";
import BookWIthSubModal from "./modals/BookWIthSubModal";
import ProfilePlaceHolder from "../../assets/ProfilePlaceHolder.png";
import NoImagePlaceholder from "../../assets/NoImagePlaceholder.png";
export default function BookThemIntoMyClass() {
  const { eventId, date } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [bookings, setBookings] = useState(false);
  const { user,dispatch } = useAuthContext();
  const [event, setEvent] = useState(null);
  const [subs, setSubs] = useState([]);
  const [classTokens, setClassTokens] = useState(false);
  const [bookWithTokesModal, setBookWithTokesModal] = useState(false);
  const [bookWithSubsModal, setBookWithSubsModal] = useState(false);
  const [selectedBookingProfile, setSelecetedBookingProfile] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSub, setSelectedSub] = useState(null);
  const [club, setClub] = useState(null);

  const navi = useNavigate();

  const cancelModal = () => {
    setBookWithTokesModal(false);
    setBookWithSubsModal(false);
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const tokeReponse = await axios.get(
        `${ApiConnectionString}/api/WhoCanBookInWithToke/${eventId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (tokeReponse.status == 200) {
        setClassTokens(tokeReponse.data);
      }

      const subReponse = await axios.get(
        `${ApiConnectionString}/api/WhoCanBookInWithSub/${eventId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (subReponse.status == 200) {
        setSubs(subReponse.data);
      }

      const eventResponse = await axios.get(
        `${ApiConnectionString}/api/event/${eventId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (eventResponse.status == 200) {
        setEvent(eventResponse.data);
      }

      const bookingResponse = await axios.get(
        `${ApiConnectionString}/api/BookingsByEvent/${eventId}/${date}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      setBookings(bookingResponse.data);

      const clubResponse = await axios.get(
        `${ApiConnectionString}/api/club/${eventResponse.data.clubId}`
      );

      if (clubResponse.status == 200) {
        setClub(clubResponse.data);
      }
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error fetching the event or bookings:", error);
      // Optionally, you could set an error state or notify the user here
    } finally {
      // Always set loading to false after fetching data
      setIsLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [bookWithTokesModal, bookWithSubsModal, user]);



  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else if (event != null) {
return (
  <div className="container py-4 bg-white rounded shadow-sm">

      <h2 className="fw-bold mb-0 text-center">Book Customers Into {event.name}</h2>
 

    <div className="row my-4">
      <div className="col-md-6 text-center">
        <h5 className="fw-bold mb-2">Club</h5>
        <p
          onClick={() => navi(`/myoneclub/${club.id}`)}
          className="text-danger fw-semibold pointer"
        >
          {club.name}
        </p>
        <div
          className="circle-crop mx-auto"
          onClick={() => navi(`/myoneclub/${club.id}`)}
        >
          <img
            src={
              club.image
                ? `${ApiConnectionString}/api/ClubProfileImage/${club.id}`
                : NoImagePlaceholder
            }
            alt="Club"
            className="img-fluid pointer"
          />
        </div>
      </div>

      <div className="col-md-6 text-center mt-2`">
   
        <div className="day-date-box text-white py-2 rounded mb-2">
          <p className="mb-0 fw-semibold">{date}</p>
          <p className="mb-0">{event.day}</p>
        </div>
        <div className="bg-light py-2 rounded">
          <p className="h5 fw-bold mb-1">{event.name}</p>
          <p className="small mb-1">{event.description}</p>
          <p className="mb-0">Time in {event.timeIn}</p>
          <p className="mb-0">Time out {event.timeOut}</p>
        </div>
      </div>
    </div>

    <details className="mb-3">
      <summary className="fw-bold">Currently Booked In</summary>
      <div className="mt-3">
        {bookings.length === 0 ? (
          <p>No customers are currently booked in.</p>
        ) : (
          bookings.map((booking) => (
            <div
              className="d-flex flex-wrap align-items-center border rounded p-3 mb-3 shadow-sm"
              key={booking.viewBookingProfile.id}
            >
              <img
                src={
                  booking.viewBookingProfile.image
                    ? `${ApiConnectionString}/api/profileImage/${booking.viewBookingProfile.id}`
                    : ProfilePlaceHolder
                }
                alt="Profile"
                width={120}
                className="circle-crop me-4"
              />
              <div className="me-4">
                <small className="text-danger">Main Profile</small>
                <p className="fw-bold">{booking.viewAppUser.username}</p>
              </div>
              <div className="me-4">
                <small className="text-danger">Username</small>
                <p className="fw-bold">{booking.viewBookingProfile.username}</p>
              </div>
              <div>
                <small className="text-danger">Name</small>
                <p className="fw-bold">
                  {booking.viewBookingProfile.firstName} {booking.viewBookingProfile.lastName}
                </p>
              </div>
            </div>
          ))
        )}
      </div>
    </details>

    <details className="mb-3">
      <summary className="fw-bold">Book in with Subscription</summary>
      <div className="mt-3">
        <p>Book customers into these classes using their subscriptions</p>
        <div className="table-responsive d-none d-md-block">
          <table className="table table-bordered table-striped align-middle">
            <thead className="table-primary">
              <tr>
                <th>Product Name</th>
                <th>Profile Name</th>
                <th>Username</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {subs.map((sub) => {
                const alreadyBooked = bookings.some(
                  (b) => b.viewBookingProfile.id === sub.profileId
                );
                return (
                  <tr
                    key={sub.id}
                    className="pointer"
                    onClick={() => {
                      setSelectedSub(sub);
                      setBookWithSubsModal(true);
                    }}
                  >
                    <td>{sub.name}</td>
                    <td>
                      {sub.viewBookingProfile.firstName} {sub.viewBookingProfile.lastName}
                    </td>
                    <td>{sub.viewBookingProfile.username}</td>
                    <td className="text-success">
                      {alreadyBooked ? "Already booked in" : ""}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="d-block d-md-none">
          {subs.map((sub) => {
            const alreadyBooked = bookings.some(
              (b) => b.viewBookingProfile.id === sub.profileId
            );
            return (
              <div
                key={sub.id}
                className="card mb-3 shadow-sm pointer"
                onClick={() => {
                  setSelectedSub(sub);
                  setBookWithSubsModal(true);
                }}
              >
                <div className="card-body">
                  <h5 className="card-title">{sub.name}</h5>
                  <p className="mb-1">
                    <strong>Profile:</strong> {sub.viewBookingProfile.firstName} {sub.viewBookingProfile.lastName}
                  </p>
                  <p className="mb-1">
                    <strong>Username:</strong> {sub.viewBookingProfile.username}
                  </p>
                  {alreadyBooked && (
                    <p className="text-success fw-bold mb-0">Already booked in</p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </details>

    <details className="mb-3">
      <summary className="fw-bold">Book in with Class Pass</summary>
      <div className="mt-3">
        <p>Book customers into these classes using class tokens. You will need to select which profile the customer uses.</p>
        {Object.values(
          classTokens.reduce((acc, item) => {
            const key = item.appUser.username;
            if (!acc[key]) acc[key] = { username: key, tokens: [] };
            acc[key].tokens.push(item);
            return acc;
          }, {})
        ).map((group) => (
          <div key={group.username} className="mb-4">
            <h6 className="fw-bold">{group.username}</h6>

            <div className="table-responsive d-none d-md-block">
              <table className="table table-bordered table-striped align-middle">
                <thead className="table-primary">
                  <tr>
                    <th>Classes Amount</th>
                    <th>Product Name</th>
                    <th>Select A Profile</th>
                  </tr>
                </thead>
                <tbody>
                  {group.tokens.map((item) => (
                    <tr key={item.id}>
                      <td>{item.tokenAmount}</td>
                      <td>{item.product.name}</td>
                      <td>
                        <select
                          className="form-select"
                          defaultValue=""
                          onChange={(e) => {
                            const selectedProfileId = e.target.value;
                            const selectedProfile = item.profiles.find(
                              (profile) => profile.id == selectedProfileId
                            );
                            if (selectedProfile) {
                              setSelectedProduct(item.product);
                              setSelecetedBookingProfile(selectedProfile);
                              setBookWithTokesModal(true);
                            }
                          }}
                        >
                          <option value="" disabled>Select a profile</option>
                          {item.profiles.map((profile) => (
                            <option key={profile.id} value={profile.id}>
                              {profile.firstName} {profile.lastName} ({profile.username})
                            </option>
                          ))}
                        </select>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="d-block d-md-none">
              {group.tokens.map((item) => (
                <div key={item.id} className="card mb-3 shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title">{item.product.name}</h5>
                    <p className="mb-1"><strong>Token Amount:</strong> {item.tokenAmount}</p>
                    <select
                      className="form-select mt-2"
                      defaultValue=""
                      onChange={(e) => {
                        const selectedProfileId = e.target.value;
                        const selectedProfile = item.profiles.find(
                          (profile) => profile.id == selectedProfileId
                        );
                        if (selectedProfile) {
                          setSelectedProduct(item.product);
                          setSelecetedBookingProfile(selectedProfile);
                          setBookWithTokesModal(true);
                        }
                      }}
                    >
                      <option value="" disabled>Select a profile</option>
                      {item.profiles.map((profile) => (
                        <option key={profile.id} value={profile.id}>
                          {profile.firstName} {profile.lastName} ({profile.username})
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </details>

    {bookWithTokesModal && (
      <BookWithTokenModal
        event={event}
        cancelModal={cancelModal}
        profile={selectedBookingProfile}
        product={selectedProduct}
        date={date}
      />
    )}

    {bookWithSubsModal && (
      <BookWIthSubModal
        event={event}
        cancelModal={cancelModal}
        sub={selectedSub}
        date={date}
      />
    )}
  </div>
);


  }
}
